import { HideWhenDetachedContext } from '#pplx/frontend/aether/internal/floating-ui/context.js';
import { useContext } from 'react';
export function useHideWhenDetached() {
    return useContext(HideWhenDetachedContext) ?? false;
}
//# sourceMappingURL=useHideWhenDetached.js.map